import React from "react";


class Data extends React.Component{
    render(){
        return (
            <React.Fragment>
                 <p className="ml-3 mt-3" style={{   fontSize: "23px",
                            fontWeight: "500"}}>Data</p>
                         <div className="info_data_center">
                         <div className="info_data_flex m-2">
                            <div className="info_data_left">
                                <p style={{ color: "grey",fontSize:"15px" }}>Status</p>
                                <p style={{ color: "#23C577", fontSize: "1.5rem" }}>Disarmed</p>
                            </div>
                            <div className="info_data_right">
                                <p style={{ color: "grey",fontSize:"15px"}}>Mode</p>
                                <p style={{ color: "#5E90FF", fontSize: "1.5rem" }}>Manual</p>
                            </div>
                        </div>
                        <div className="info_data_flex m-2">
                            <div className="info_data_left">
                                <p style={{ color: "grey",fontSize:"15px" }}>Battery</p>
                                <p style={{ fontSize: "1.5rem" }}>99%</p>
                            </div>
                            <div className="info_data_right">
                                <p style={{ color: "grey",fontSize:"15px"}}>Latitude</p>
                                <p style={{ fontSize: "1.5rem" }}>47.39</p>
                            </div>
                        </div>
                        <div className="info_data_flex m-2">
                            <div className="info_data_left">
                                <p style={{ color: "grey",fontSize:"15px"}}>Speed</p>
                                <p style={{ fontSize: "1.5rem" }}>0.0</p>
                            </div>
                            <div className="info_data_right m-2">
                                <p style={{ color: "grey" }}>Longitude</p>
                                <p style={{ fontSize: "1.5rem" }}>8.5</p>
                            </div>
                        </div>
                        <div className="info_data_flex m-2">
                            <div className="info_data_left">
                                <p style={{ color: "grey",fontSize:"15px" }}>Voltage</p>
                                <p style={{ fontSize: "1.5rem" }}>12.8</p>
                            </div>
                            <div className="info_data_right">
                                <p style={{ color: "grey",fontSize:"15px" }}>GPS Status</p>
                                <p style={{ fontSize: "1.5rem" }}>FIX</p>
                            </div>
                        </div>
                        <div className="info_data_flex m-2">
                            <div className="info_data_left">
                                <p style={{ color: "grey",fontSize:"15px" }}>Pitch(Deg)</p>
                                <p style={{ fontSize: "1.5rem" }}>-0.00</p>
                            </div>
                            <div className="info_data_right">
                                <p style={{ color: "grey",fontSize:"15px" }}>Status</p>
                                <p style={{ color: "#23C577", fontSize: "1.5rem" }}>OK</p>
                            </div>
                        </div>
                        <div className="info_data_flex m-2">
                            <div className="info_data_left">
                                <p style={{ color: "grey",fontSize:"15px" }}>Distance</p>
                                <p style={{ fontSize: "1.5rem" }}>Null</p>
                            </div>
                            <div className="info_data_right">
                                <p style={{ color: "grey",fontSize:"15px" }}>Temperature</p>
                                <p style={{ fontSize: "1.5rem" }}>25.3</p>
                            </div>
                        </div>
                         </div>
                        <div className="info_data_flex_gradient pl-4">
                        <p style={{ textAlign:"left",fontSize:"15px"}}>Uptime</p>
                        <p style={{fontSize: "1.5rem",textAlign:"left"}}>250<small>hrs</small> 50<small>min</small> 43<small>sec</small></p>
                        </div>
            </React.Fragment>
        )
    }
}


export default Data;